import { render, staticRenderFns } from "./DashboardSection.vue?vue&type=template&id=d040c7aa&scoped=true"
import script from "./DashboardSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DashboardSection.vue?vue&type=style&index=0&id=d040c7aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d040c7aa",
  null
  
)

export default component.exports